import { render, staticRenderFns } from "./ProfileAdditionalDetails.vue?vue&type=template&id=26b4d792"
import script from "./ProfileAdditionalDetails.vue?vue&type=script&lang=js"
export * from "./ProfileAdditionalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports